/**
 * Medidas de layout compartilhadas entre componentes que precisam concordar.
 *
 * A altura do menu fixo da landing vivia como `h-14` no `<nav>` e em mais nenhum
 * lugar — o herói, que ocupa a tela inteira **atrás** dele, centralizava o
 * conteúdo na viewport toda, sem saber que os 56px do topo estavam cobertos.
 * Conteúdo mais alto (a mesma frase em português ocupa três linhas onde o inglês
 * ocupa duas) crescia para os dois lados e encostava o topo no menu.
 *
 * As duas medidas moram aqui para não poderem divergir: mudar a altura do menu
 * sem mudar a reserva do herói é o caminho de volta para o mesmo bug.
 */

/** Altura do menu fixo da landing, em px. `h-14` = 3.5rem. */
export const TOP_NAV_HEIGHT_PX = 56;

/** Classe que dimensiona o `<nav>`. */
export const TOP_NAV_HEIGHT_CLASS = "h-14";

/** Classe que reserva a altura do menu em quem centraliza conteúdo sob ele. */
export const TOP_NAV_OFFSET_CLASS = "pt-14";
